import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  ActiveYearResponse,
  ActiveYearUpsertRequest,
  CustomerReportRebuildSettings,
  LoginAttemptCleanupSettings
} from '../models/api/appSettings';

@Injectable({
  providedIn: 'root'
})
export class AppSettingsService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/app-settings`;

  /**
   * GET /api/app-settings/active-year
   * Get the currently configured active business year.
   */
  getActiveYear(): Observable<ActiveYearResponse> {
    return this.http.get<ActiveYearResponse>(`${this.apiUrl}/active-year`);
  }

  /**
   * PUT /api/app-settings/active-year
   * Upsert the active business year.
   */
  upsertActiveYear(request: ActiveYearUpsertRequest): Observable<ActiveYearResponse> {
    return this.http.put<ActiveYearResponse>(`${this.apiUrl}/active-year`, request);
  }

  /**
   * GET /api/app-settings/login-attempt-cleanup
   * Get the scheduled login-attempt cleanup settings.
   */
  getLoginAttemptCleanupSettings(): Observable<LoginAttemptCleanupSettings> {
    return this.http.get<LoginAttemptCleanupSettings>(`${this.apiUrl}/login-attempt-cleanup`);
  }

  /**
   * PUT /api/app-settings/login-attempt-cleanup
   * Update the scheduled login-attempt cleanup settings.
   */
  updateLoginAttemptCleanupSettings(
    request: LoginAttemptCleanupSettings
  ): Observable<LoginAttemptCleanupSettings> {
    return this.http.put<LoginAttemptCleanupSettings>(`${this.apiUrl}/login-attempt-cleanup`, request);
  }

  /**
   * GET /api/app-settings/customer-report-rebuild
   * Get the nightly customer-report rebuild settings.
   */
  getCustomerReportRebuildSettings(): Observable<CustomerReportRebuildSettings> {
    return this.http.get<CustomerReportRebuildSettings>(`${this.apiUrl}/customer-report-rebuild`);
  }

  /**
   * PUT /api/app-settings/customer-report-rebuild
   * Update the nightly customer-report rebuild settings.
   */
  updateCustomerReportRebuildSettings(
    request: CustomerReportRebuildSettings
  ): Observable<CustomerReportRebuildSettings> {
    return this.http.put<CustomerReportRebuildSettings>(`${this.apiUrl}/customer-report-rebuild`, request);
  }
}
